import { ILog } from '../../../models/ILog';

export function isShowOpGraph(log: ILog) {
    try {
        const ctxData = JSON.parse(log.context);
        if (ctxData && (ctxData.opGraphId || ctxData.opGraph)) {
            return true;
        }
    } catch (error) {

    }

    return false;
}

export function getOpGraphId(log: ILog) {
    try {
        const ctxData = JSON.parse(log.context);
        if (ctxData && ctxData.opGraphId) {
            return ctxData.opGraphId;
        }
    } catch (error) {

    }

    return null;
}

export function getOpGraphData(log: ILog) {
    try {
        const ctxData = JSON.parse(log.context);
        if (ctxData && ctxData.opGraph) {
            return ctxData.opGraph;
        }
    } catch (error) {

    }

    return null;
}